import { useContext, useEffect, useMemo, useState } from "react";
import { AudiovisualCreation } from "../../../../../generated/data-contracts";
import { CreationType } from "../../../../../models";
import { api } from "../../../../../utils";
import { AvisLoader } from "../../../../shared/components";
import {
  AvisField,
  AvisGrid,
  AvisSection,
  AvisTitleAndSubtitle,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  CreationAdditionalInfo,
  CreationCueSheets,
  CreationNames,
  CreationNumbers,
  CreationOtherInfo,
  CreationRightsHolders,
} from "../sections";
import { CreationBasePage, ICreationBasePageProps } from "./CreationBasePage";

export function CreationPageAudioVisual(
  props: Readonly<ICreationBasePageProps>,
) {
  const { urlParams, setError } = props;
  const { res } = useContext(AvisContext);
  const [creationInfo, setCreationInfo] = useState<
    AudiovisualCreation | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getCreationInfo = useMemo(() => {
    if (!urlParams.rightsHolderId) return;
    if (!urlParams.creationId) return;
    setIsLoading(true);

    api
      .rightsHoldersGetAudiovisualCreation(
        urlParams.rightsHolderId,
        urlParams.creationId,
      )
      .then((res) => setCreationInfo(res.data))
      .catch(setError)
      .finally(() => setIsLoading(false));
  }, [urlParams, setError]);

  useEffect(() => {
    getCreationInfo;
  }, [getCreationInfo]);
  if (isLoading) return <AvisLoader inline />;

  return (
    <CreationBasePage data={creationInfo} {...props}>
      <AvisTitleAndSubtitle
        title={creationInfo?.creationName}
        subTitle={creationInfo?.creationGenreName}
      />
      <AvisSection>
        <AvisGrid>
          <AvisField
            title={res("authors_Creation_label_AKKACode")}
            value={creationInfo?.creationNumber}
          />
          <AvisField
            title={res("authors_Creation_label_Year")}
            value={creationInfo?.manufactureYear}
          />
          <AvisField
            title={res("authors_Creation_label_Timing")}
            value={creationInfo?.totalTiming}
          />
        </AvisGrid>
      </AvisSection>
      <CreationRightsHolders
        data={creationInfo?.rightsHolders}
        creationType={creationInfo?.creationClassCode as CreationType}
      />
      <CreationAdditionalInfo data={creationInfo?.producers} />
      <CreationNames data={creationInfo?.creationNameValues} />
      <CreationNumbers data={creationInfo?.creationNumberValues} />
      <CreationCueSheets
        data={creationInfo?.cueSheet}
        totalTiming={creationInfo?.musicTiming}
      />
      <CreationOtherInfo
        creationRegistered={creationInfo?.creationDate}
        creationStatus={creationInfo?.creationStatusNamePortal}
        statusNotes={creationInfo?.statusNotes}
      />
    </CreationBasePage>
  );
}
